<template>
  <div>
    <!-- Data Stores Hack, need to be loaded first -->
    <CallStore ref="callStore"/>
    <CallTakerStore ref="callTakerStore"/>
    <TwilioSyncStore ref="twilioSyncStore"/>
    <!-- ///////////////////////////////////////// -->

    <h1>Phone Debug Page</h1>
    
    <CallTakers />
    <PhoneDebugTable :syncClient="syncClient" />
    <CallStats />
    
  </div>
</template>

<script>
import PhoneDebugTable from './Components/PhoneDebugTable.vue'
import CallTakers from './Components/CallTakers.vue'
import CallStats from './Components/CallStats.vue'

import CallStore from './Stores/CallStore.vue'
import CallTakerStore from './Stores/CallTakerStore.vue'
import TwilioSyncStore from './Stores/TwilioSyncStore.vue'
export default {
  name:"PhoneDebugPage",
  components: {PhoneDebugTable, CallTakers, CallStats,      CallStore, CallTakerStore, TwilioSyncStore},
  data () { return {
    syncClient: undefined,
    callStore: {},
  }},
  provide() {
    return {
      phonePage: this
    }
  },
  async mounted(){
    // this.$options.provide = {callStore: this.$refs.callStore}
    // this.$set(this.$options.provide, 'callStore' ,this.$refs.callStore)
    // console.log(this.$options.provide)
    // this.callStore = this.$refs.callStore;
     
     //TODO Twilio sync code should be lazy loaded

      const syncTokenURL = `https://fandango-wombat-7897.twil.io/sync_access_token?k=${this.$_auid}`
      const r = await axios.get(syncTokenURL)
      this.syncClient = new Twilio.Sync.Client(r.data.token);
      
      this.syncClient.on('tokenAboutToExpire', async () => {
        console.log('Updating Token')
        const r = await axios.get(syncTokenURL)
        this.syncClient.updateToken(r.data.token);
      }); 
  },
  
  
}
</script>

<style scoped>

</style>